import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import * as AssetBusinessType from 'ecosystem-marketplace-core/constants/groupTags/AssetBusinessType';
import * as AssetPageFeature from 'ecosystem-marketplace-core/constants/groupTags/AssetPageFeature';
import * as AssetPageType from 'ecosystem-marketplace-core/constants/groupTags/AssetPageType';
import AssetBusinessTypeUrls from '../constants/urls/AssetBusinessType';
import AssetPageFeatureUrls from '../constants/urls/AssetPageFeature';
import AssetPageTypeUrls from '../constants/urls/AssetPageType';

function getKeyByValue(obj, value) {
  return Object.keys(obj).find(key => {
    return obj[key] === value;
  });
}

function getParamEnumValue(type, value) {
  if (!value) return undefined;
  let routes;
  let enumObj;

  if (type === 'businessType') {
    routes = AssetBusinessTypeUrls;
    enumObj = AssetBusinessType;
  } else if (type === 'pageType') {
    routes = AssetPageTypeUrls;
    enumObj = AssetPageType;
  } else {
    routes = AssetPageFeatureUrls;
    enumObj = AssetPageFeature;
  }

  const routeKey = getKeyByValue(routes, value);
  return routeKey ? enumObj[routeKey] : undefined;
}

export function useStorefrontRouteParams() {
  const {
    businessType,
    pageFeature,
    pageNumber,
    pageType
  } = useParams();
  const businessTypeValue = useMemo(() => {
    return getParamEnumValue('businessType', businessType);
  }, [businessType]);
  const pageTypeValue = useMemo(() => {
    return getParamEnumValue('pageType', pageType);
  }, [pageType]);
  const pageFeatureValue = useMemo(() => {
    return getParamEnumValue('pageFeature', pageFeature);
  }, [pageFeature]);
  const computedPageNumber = useMemo(() => {
    return pageNumber ? parseInt(pageNumber, 10) : 1;
  }, [pageNumber]);
  const parsedParams = useMemo(() => {
    const params = {
      businessType: businessTypeValue,
      pageFeature: pageFeatureValue,
      pageNumber: computedPageNumber,
      pageType: pageTypeValue
    };
    const paramValueTuples = [['businessType', businessTypeValue], ['pageType', pageTypeValue], ['pageFeature', pageFeatureValue]];

    for (const [param, value] of paramValueTuples) {
      if (value == null) {
        delete params[param];
      }
    }

    return params;
  }, [businessTypeValue, computedPageNumber, pageFeatureValue, pageTypeValue]);
  return parsedParams;
}